// import React, { useState, useEffect } from "react";
// import ShowSavedPrescription from "../presecription/ShowSavedPrescription";
// import ValidPrescriptionFormat from "../presecription/ValidPrescriptionFormat";
// import { apiGET, apiPOST, apiPUT } from '../../utilities/apiHelpers';
// import { API_URL } from '../../config';
// import { useSelector } from "react-redux";
// import FileUploadInput from "../Input/FileUploadInput";
// import { toast } from "react-toastify";
// import scrollToTop from "../../utilities/scrollToTop";
// import ButtonWithLoader from "../Button/ButtonWithLoader";

// const EnquiryUploadPrescription = ({ type, setCurrentStep, stepperProgressCartData, setStepperProgressCartData }) => {
//     const [savedPrescription, setSavedPrescription] = useState([]);
//     const [selectedImageIndexes, setSelectedImageIndexes] = useState([]);
//     const [selectedImageUrl, setSelectedImageUrl] = useState([]);
//     const [uploadedFileUrl, setUploadedFileUrl] = useState(null);
//     const [uploadStatus, setUploadStatus] = useState('');
//     const [loading, setLoading] = useState(false);
//     const userId = useSelector((state) => state.user?.userData?.id) || ""

//     const getAllSavedPrescription = async () => {
//         try {
//             const response = await apiGET(`${API_URL}/v1/prescription/get-prescription-by-user/${userId}`);
//             if (response?.data?.status) {
//                 setSavedPrescription(response?.data?.data?.data);
//             } else {
//                 console.error("Something went wrong");
//                 setSavedPrescription([]);
//             }
//         } catch (error) {
//             console.error("Something went wrong", error);
//             setSavedPrescription([]);
//         }
//     };

//     const selectedPrescription = async () => {
//         if (selectedImageUrl.length) {
//             const updateStepperProgressPayload = {
//                 selectedPrescription: selectedImageUrl,
//             }
//             console.log("selectedImageUrl", selectedImageUrl);
//             try {
//                 setLoading(true)
//                 const userStepperAddResponse = await apiPUT(`${API_URL}/v1/stepper-progress/update-stepper-progress/${userId}`, updateStepperProgressPayload);
//                 console.log("userStepperAddResponse", userStepperAddResponse);
//                 if (userStepperAddResponse.status) {
//                     const stepperResponse = await apiGET(`${API_URL}/v1/stepper-progress/user-stepper-progress/${userId}`)
//                     setStepperProgressCartData(stepperResponse.data?.data);
//                 }
//             } catch (error) {
//                 setLoading(false)
//                 console.log("Error updating seleted prescription", error);
//             }
//             if (type === 'uploadPrescription') {
//                 setCurrentStep();
//             }

//         }
//         else {
//             setLoading(false)
//             toast.error("Upload or Select Prescription to proceed")
//         }
//     }

//     const uploadPrescription = async () => {
//         try {
//             const prescriptionPayload = {
//                 userId: userId,
//                 prescriptionImgUrl: uploadedFileUrl,
//                 title: "Test 1"
//             }
//             const prescriptionResponse = await apiPOST(`${API_URL}/v1/prescription/add-prescription-img`, prescriptionPayload);
//             if (prescriptionResponse) {
//                 toast.success("Prescription Added successfully!");
//                 setUploadStatus('File uploaded successfully!');
//                 console.log("prescriptionResponse", prescriptionResponse.data.data.data);
//                 if (type === "uploadPrescription") {
//                     const updateStepperProgressPayload = {
//                         selectedPrescription: prescriptionResponse.data.data.data
//                     }
//                     try {
//                         const userStepperAddResponse = await apiPUT(`${API_URL}/v1/stepper-progress/update-stepper-progress/${userId}`, updateStepperProgressPayload);
//                     } catch (error) {
//                         console.log("Error updating stepper progress for user");
//                     }
//                 }
//                 getAllSavedPrescription()
//             } else {
//                 setUploadStatus('Failed to upload file.');
//             }
//         } catch (error) {
//             console.log("Error", error);
//         }
//     }

//     useEffect(() => {
//         scrollToTop()
//         getAllSavedPrescription();
//     }, [uploadStatus]); // Trigger fetch on initial render and whenever uploadStatus changes

//     useEffect(() => {
//         if (uploadedFileUrl) {
//             uploadPrescription();
//         }
//     }, [uploadedFileUrl]); // Trigger fetch on initial render and whenever uploadStatus changes
//     return (
//         <div className="bg-white p-8 rounded-lg shadow-lg mt-4 w-full">
//             <label className="block mb-2 text-lg font-bold text-gray-700">
//                 Upload Prescription
//             </label>
//             <div className="md:flex justify-between w-full">
//                 <div className="flex flex-col w-full">
//                     <FileUploadInput setUploadedFileUrl={setUploadedFileUrl} />
//                     {
//                         <ShowSavedPrescription
//                             selectedImageIndexes={selectedImageIndexes}
//                             savedPrescription={savedPrescription}
//                             setSelectedImageIndexes={setSelectedImageIndexes}
//                             setSelectedImageUrl={setSelectedImageUrl} />
//                     }
//                     <div className="flex justify-end">
//                         <ButtonWithLoader loading={loading} buttonText={"Submit"} onClick={selectedPrescription} width={"w-[100px]"} />
//                     </div>
//                 </div>
//                 <div className="border-l border-gray-300 ml-4 mr-8"></div>
//                 <div>
//                     <ValidPrescriptionFormat />
//                 </div>
//             </div>
//         </div>
//     );
// }
// export default EnquiryUploadPrescription;


// import React, { useState, useEffect, useCallback } from "react";
// import ShowSavedPrescription from "../presecription/ShowSavedPrescription";
// import ValidPrescriptionFormat from "../presecription/ValidPrescriptionFormat";
// import { apiGET, apiPOST, apiPUT } from "../../utilities/apiHelpers";
// import { API_URL } from "../../config";
// import { useSelector } from "react-redux";
// import FileUploadInput from "../Input/FileUploadInput";
// import { toast } from "react-toastify";
// import scrollToTop from "../../utilities/scrollToTop";
// import ButtonWithLoader from "../Button/ButtonWithLoader";

// const EnquiryUploadPrescription = ({
//     type,
//     setCurrentStep,
//     stepperProgressCartData,
//     setStepperProgressCartData,
// }) => {
//     const [savedPrescription, setSavedPrescription] = useState([]);
//     const [selectedImageIndexes, setSelectedImageIndexes] = useState([]);
//     const [selectedImageUrl, setSelectedImageUrl] = useState([]);
//     const [uploadedFileUrl, setUploadedFileUrl] = useState(null);
//     const [uploadStatus, setUploadStatus] = useState("");
//     const [loading, setLoading] = useState(false);

//     const userId = useSelector((state) => state.user?.userData?.id) || "";

//     /* ================= GET SAVED PRESCRIPTIONS ================= */
//     const getAllSavedPrescription = useCallback(async () => {
//         try {
//             const response = await apiGET(
//                 `${API_URL}/v1/prescription/get-prescription-by-user/${userId}`
//             );
//             if (response?.data?.status) {
//                 setSavedPrescription(response.data.data.data);
//             } else {
//                 setSavedPrescription([]);
//             }
//         } catch (error) {
//             console.error(error);
//             setSavedPrescription([]);
//         }
//     }, [userId]);

//     /* ================= UPLOAD PRESCRIPTION ================= */
//     const uploadPrescription = useCallback(async () => {
//         if (!uploadedFileUrl) return;

//         try {
//             const payload = {
//                 userId,
//                 prescriptionImgUrl: uploadedFileUrl,
//                 title: "Prescription",
//             };

//             const res = await apiPOST(
//                 `${API_URL}/v1/prescription/add-prescription-img`,
//                 payload
//             );

//             if (res?.data?.status) {
//                 toast.success("Prescription added successfully");
//                 setUploadStatus("success");

//                 if (type === "uploadPrescription") {
//                     await apiPUT(
//                         `${API_URL}/v1/stepper-progress/update-stepper-progress/${userId}`,
//                         { selectedPrescription: res.data.data.data }
//                     );
//                 }

//                 getAllSavedPrescription();
//             }
//         } catch (error) {
//             console.error(error);
//         }
//     }, [uploadedFileUrl, userId, type, getAllSavedPrescription]);

//     /* ================= SELECT PRESCRIPTION ================= */
//     const selectedPrescription = async () => {
//         if (!selectedImageUrl.length) {
//             toast.error("Upload or select prescription to proceed");
//             return;
//         }

//         try {
//             setLoading(true);
//             const res = await apiPUT(
//                 `${API_URL}/v1/stepper-progress/update-stepper-progress/${userId}`,
//                 { selectedPrescription: selectedImageUrl }
//             );

//             if (res?.status) {
//                 const stepperRes = await apiGET(
//                     `${API_URL}/v1/stepper-progress/user-stepper-progress/${userId}`
//                 );
//                 setStepperProgressCartData(stepperRes.data?.data);
//                 if (type === "uploadPrescription") setCurrentStep();
//             }
//         } catch (error) {
//             console.error(error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     /* ================= EFFECTS ================= */
//     useEffect(() => {
//         scrollToTop();
//         getAllSavedPrescription();
//     }, [getAllSavedPrescription, uploadStatus]);

//     useEffect(() => {
//         uploadPrescription();
//     }, [uploadPrescription]);

//     /* ================= UI ================= */
//     return (
//         <div className="bg-white p-8 rounded-lg shadow-lg mt-4 w-full">
//             <label className="block mb-2 text-lg font-bold text-gray-700">
//                 Upload Prescription
//             </label>

//             <div className="md:flex justify-between w-full">
//                 <div className="flex flex-col w-full">
//                     <FileUploadInput setUploadedFileUrl={setUploadedFileUrl} />

//                     <ShowSavedPrescription
//                         selectedImageIndexes={selectedImageIndexes}
//                         savedPrescription={savedPrescription}
//                         setSelectedImageIndexes={setSelectedImageIndexes}
//                         setSelectedImageUrl={setSelectedImageUrl}
//                     />

//                     <div className="flex justify-end">
//                         <ButtonWithLoader
//                             loading={loading}
//                             buttonText="Submit"
//                             onClick={selectedPrescription}
//                             width="w-[100px]"
//                         />
//                     </div>
//                 </div>

//                 <div className="border-l border-gray-300 ml-4 mr-8" />

//                 <ValidPrescriptionFormat />
//             </div>
//         </div>
//     );
// };

// export default EnquiryUploadPrescription;


import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom"; // Import for navigation
import ShowSavedPrescription from "../presecription/ShowSavedPrescription";
import ValidPrescriptionFormat from "../presecription/ValidPrescriptionFormat";
import { apiGET, apiPOST, apiPUT } from "../../utilities/apiHelpers";
import { API_URL } from "../../config";
import { useSelector } from "react-redux";
import FileUploadInput from "../Input/FileUploadInput";
import { toast } from "react-toastify";
import scrollToTop from "../../utilities/scrollToTop";
import ButtonWithLoader from "../Button/ButtonWithLoader";

const EnquiryUploadPrescription = ({
    type,
    setCurrentStep,
    setStepperProgressCartData,
}) => {
    const navigate = useNavigate(); // Initialize navigation
    const [savedPrescription, setSavedPrescription] = useState([]);
    const [selectedImageIndexes, setSelectedImageIndexes] = useState([]);
    const [selectedImageUrl, setSelectedImageUrl] = useState([]);
    const [uploadedFileUrl, setUploadedFileUrl] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [loading, setLoading] = useState(false);

    const userId = useSelector((state) => state.user?.userData?.id) || "";

    /* ================= 1. FETCH SAVED PRESCRIPTIONS ================= */
    const getAllSavedPrescription = useCallback(async () => {
        if (!userId) return;
        try {
            const response = await apiGET(
                `${API_URL}/v1/prescription/get-prescription-by-user/${userId}`
            );
            // Matches your JSON structure: status: true
            if (response?.data?.status) {
                setSavedPrescription(response.data.data.data || []);
            }
        } catch (error) {
            console.error("Error fetching prescriptions", error);
        }
    }, [userId]);

    /* ================= 2. AUTO-UPLOAD ON FILE SELECTION ================= */
    const handleAutoUpload = useCallback(async () => {
        if (!uploadedFileUrl || !userId) return;

        try {
            setIsUploading(true);
            const payload = {
                userId: userId,
                prescriptionImgUrl: uploadedFileUrl,
                title: "Prescription Upload"
            };

            const res = await apiPOST(`${API_URL}/v1/prescription/add-prescription-img`, payload);
            
            if (res?.data?.status) {
                // toast.success("Prescription uploaded successfully!");
                setUploadedFileUrl(null); // Clear temp state
                await getAllSavedPrescription(); // Refresh the selection list
            }
        } catch (error) {
            console.error("Upload Error", error);
            toast.error("Failed to upload file to server");
        } finally {
            setIsUploading(false);
        }
    }, [uploadedFileUrl, userId, getAllSavedPrescription]);

    /* ================= 3. SUBMIT & NAVIGATE ================= */
    /* ================= 3. SUBMIT & NAVIGATE ================= */
const handleSubmit = async () => {
    if (!selectedImageUrl || selectedImageUrl.length === 0) {
        toast.error("Please select a prescription to proceed");
        return;
    }

    try {
        setLoading(true);
        const res = await apiPUT(
            `${API_URL}/v1/stepper-progress/update-stepper-progress/${userId}`,
            { selectedPrescription: selectedImageUrl }
        );

        if (res?.data?.status === true) {
            const stepperRes = await apiGET(
                `${API_URL}/v1/stepper-progress/user-stepper-progress/${userId}`
            );

            if (stepperRes?.data?.status === true) {
                if (typeof setStepperProgressCartData === "function") {
                    setStepperProgressCartData(stepperRes.data.data);
                }

                toast.success("Prescription confirmed");

                // --- FIXING THE UNUSED VAR ERROR HERE ---
                if (type === "uploadPrescription") {
                    if (typeof setCurrentStep === "function") {
                        setCurrentStep(); // Moves the stepper forward
                    }
                    navigate("/upload-prescription");
                }
            }
        }
    } catch (error) {
        console.error("Submission Error:", error);
        toast.error("Unable to proceed");
    } finally {
        setLoading(false);
    }
};

    /* ================= EFFECTS ================= */
    useEffect(() => {
        scrollToTop();
        getAllSavedPrescription();
    }, [getAllSavedPrescription]);

    useEffect(() => {
        if (uploadedFileUrl) {
            handleAutoUpload();
        }
    }, [uploadedFileUrl, handleAutoUpload]);

    return (
        <div className="bg-white p-8 rounded-lg shadow-lg mt-4 w-full">
            <label className="block mb-2 text-lg font-bold text-gray-700">
                Upload Prescription
            </label>

            <div className="md:flex justify-between w-full">
                <div className="flex flex-col w-full">
                    {/* File Input and Upload Loader */}
                    <div className="relative mb-4">
                        <FileUploadInput setUploadedFileUrl={setUploadedFileUrl} />
                        {isUploading && (
                            <p className="text-xs text-blue-500 mt-1 animate-pulse font-semibold">
                                Processing upload...
                            </p>
                        )}
                    </div>

                    {/* Prescription Selector Grid */}
                    <ShowSavedPrescription
                        selectedImageIndexes={selectedImageIndexes}
                        savedPrescription={savedPrescription}
                        setSelectedImageIndexes={setSelectedImageIndexes}
                        setSelectedImageUrl={setSelectedImageUrl}
                    />

                    {/* Submit Button */}
                    <div className="flex justify-end mt-6">
                        <ButtonWithLoader
                            loading={loading}
                            buttonText="Submit"
                            onClick={handleSubmit}
                            width="w-[120px]"
                        />
                    </div>
                </div>

                {/* Vertical Divider for Desktop */}
                <div className="hidden md:block border-l border-gray-300 mx-8" />

                {/* Right Side: Educational Content */}
                <div className="mt-6 md:mt-0">
                    <ValidPrescriptionFormat />
                </div>
            </div>
        </div>
    );
};

export default EnquiryUploadPrescription;

